import { Spinner } from '@creditornot/cb-ingredients';
import { Toast as CookbookToast } from '@creditornot/cb-toast';
import { ToastVariant } from '@creditornot/cb-toast';
import React from 'react';
import toast, { Renderable } from 'react-hot-toast';
import styled from 'styled-components';

export const StyledToast = styled(CookbookToast)`
  width: 400px;
`;

export const MessageContainer = styled.div`
  display: flex;
  align-items: center;
  /* adjust react-hot-toast inner message div to look good with cb-toast */
  > div {
    display: block;
    margin: 0;
  }
`;

export const StyledSpinner = styled(Spinner)`
  margin-inline-end: 4px;
`;

type Props = {
  variant: ToastVariant;
  title: string;
  message: Renderable;
  toastId: string;
};

const Toast = ({ variant, title, message, toastId }: Props) => (
  <StyledToast variant={variant} title={title} onCloseButtonClick={() => toast.dismiss(toastId)}>
    <MessageContainer>{message}</MessageContainer>
  </StyledToast>
);

export default Toast;
